import { getConfig } from "../../../hooks/use-config";
import { validationMessage } from "../../../utils/validation";

export const onChangeCompanyInfo = (props, cb) => {
  let detailData = {};
  const { value, key, formFields } = props;
  const updateFormFields = { ...formFields };

  updateFormFields[key].value = value;

  detailData = { updatedFields: updateFormFields };
  cb(detailData);
};

export const formProfileData = (formFields, user) => {
  for (let element in formFields) {
    formFields[element].value = user[element];
  }

  return formFields;
};

export const getSubmissionData = (formFields) => {
  const fieldsData = {};
  let required = {};

  for (let key in formFields) {
    const { elementConfigs, value } = formFields[key];

    if (value) {
      const alert = checkInputConstraints(elementConfigs, key, value);
      if (alert) {
        required[key] = alert;
      } else {
        fieldsData[key] = formFields[key].value;
      }
    } else if (elementConfigs.required && !value) {
      required[key] = validationMessage.required;
    }
  }
  return {
    fieldsData,
    required,
  };
};

const checkInputConstraints = (configs, key, value) => {
  const { maxLength, minLength } = configs;

  let errorMessage = "";

  switch (true) {
    case maxLength && value.length > maxLength:
      errorMessage = getConfig(key);
      break;
    case minLength && value.length < minLength:
      errorMessage = getConfig(key);
      break;
    case key === "email":
      const messge = checkValidEmail(value);
      errorMessage = messge;
      break;
    default:
      return errorMessage;
  }

  return errorMessage;
};

const checkValidEmail = (value) => {
  const validator =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  if (value.toLowerCase().match(validator)) {
    return "";
  } else {
    return "email is not valid";
  }
};

export const getFormDataFromLocalStorage = (supplierDetail, formDataFields) => {
  for (let key in formDataFields) {
    if (supplierDetail[key]) {
      const value = supplierDetail[key];

      formDataFields[key].value = value;
    } else {
      formDataFields[key].value = "";
    }
  }

  return formDataFields;
};
